import { TabsDesignTokens } from '@primeuix/themes/types/tabs';

export const TABS_STYLES: TabsDesignTokens = {
  tab: {
    padding: '0.875rem 1rem',
    fontWeight: '600',
    gap: '0.375rem',
  },
  tablist: { background: 'transparent' },
  tabpanel: { background: 'transparent', padding: '0.875rem 0 1.125rem' },
  css: () => `
    /* The tabs theme exposes no font-size token, and .p-tab declares a gap without a display,
       so both are set here to keep tab labels and their count badges consistent app-wide. */
    .p-tab {
      display: flex;
      align-items: center;
      font-size: 1rem;
    }

    .p-tab.p-disabled {
      pointer-events: auto;
      cursor: default;
    }`,
};
